export const findDuplicates = (arr: unknown[]): unknown[] => {
    return arr.filter((item, index) => arr.indexOf(item) != index);
};

export const anyDuplicates = (arr: unknown[]): boolean => {
    return findDuplicates(arr).length > 0;
};    